import React from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import cls from "../check-in-fixicon/style.module.scss";
import {Iconfont} from "../../../../components/icon/iconfont";

export default props => {
    useStyles(classes)
    const {selected, disabled, onClick} = props
    console.log("@selected",selected)
    return <div className={`${classes.CheckBox} ${selected ? classes.Checked : classes.UnChecked}`} onClick={onClick}>{selected &&
        <Iconfont className={classes.Duihao}>&#xe6f0;</Iconfont>}</div>
}
